module.exports = __webpack_public_path__ + "img/icon_mail.f0787d80.svg";